<template>
  <div class="global-lockscreen-container">

    <q-modal maximized
             class="global-lockscreen-no-transition"
             v-model="isShow"
             :no-esc-dismiss="true"
             :no-route-dismiss="true"
             :no-backdrop-dismiss="true"
    >
      <div class="relogin-full">
        <div class="content-group">
          <!-- 브랜드 로고 -->
          <div class="contents-row">
            <div :class="['login-logo', getProductSubBI]"></div>
          </div>

          <!-- 입력 폼 -->
          <div class="portlet" v-if="!disableReLogin">

            <div class="contents-row">
              <div class="inline-group relogin-contents">
                <div class="contents-row">
                  <span class="icon-login-pw">PASSWORD</span>
                  <q-input v-model="password"
                           no-pass-toggle
                           ref="passwdInput"
                           type="password"
                           name="password"
                           data-vv-scope="lock"
                           :error="errors.has('lock.password')"
                           v-validate="'required'"
                           @keydown.enter="onClickCheckPassword"
                           style="width:274px;"
                           class="bs bs-q-input bs-q-input-default"/>
                </div>

                <div v-if="otpEnableYn === 1"
                     class="contents-row">
                  <span class="icon-login-otp">SECUI OTP</span>
                  <q-input v-model="otpKey"
                           ref="otpKey"
                           type="text"
                           name="otpKey"
                           data-vv-scope="lock"
                           :error="errors.has('lock.otpKey')"
                           v-validate="`required|isValidNaturalNumbers`"
                           maxlength="8"
                           @keydown.enter="onClickCheckPassword"
                           style="width:274px;"
                           class="bs bs-q-input bs-q-input-default">
                    <tool-tip maxLength="8" />
                  </q-input>

                </div>

                <div class="fRight marT5">
                  <q-btn label="LOGIN"
                         color="primary"
                         class="bs bs-q-btn-md"
                         @click="onClickCheckPassword"
                  />
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
      <footer>
        <div class="copy-footer">COPYRIGHT &copy; SECUI ALL RIGHTS RESERVED.</div>
      </footer>

    </q-modal>
    <validate-dialog ref="validateDialog"/>
  </div>
</template>

<script>
  // 스토어 헬퍼
  import { createNamespacedHelpers } from 'vuex'
  import { encryptionPassword } from '~/utils/cryptoHelper'

  const commonHelper = createNamespacedHelpers('common/common')
  const lockmodeHelpers = createNamespacedHelpers('common/lockmode/')
  const myAccountSettingsHelpers = createNamespacedHelpers('common/myAccountSettings')

  export default {
    name: 'LockScreenPopup',
    components: {},
    directives: {},
    mixins: [],
    data () {
      return {
        isShow: false,
        loginId: '',
        password: '',
        otpKey: '',
        // TAMS
        disableReLogin: false,
        otpEnableYn: 0
      }
    },
    computed: {
      ...commonHelper.mapState([
        'uiData'
      ]),
      encryptionAesKey () {
        return this.$store.state.common.authenticate.encryptionAesKey
      },
      csrfToken () {
        return this.$store.state.common.authenticate.csrfToken
      },
      getProductModel () {
        const veType = _.get(this.uiData, ['system', 've_type'], 0)
        if (veType > 0) return 've'
        return 'bluemax'
      },
      getProductSubBI () {
        return `${this.getProductModel}-logo`
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...lockmodeHelpers.mapActions([
        'unlock'
      ]),
      ...myAccountSettingsHelpers.mapActions([
        'getMyAccountInfo'
      ]),
      async show (loginId, disableReLogin) {
        // TAMS
        document.body.click()

        const res = await this.getMyAccountInfo()

        if (res.code === 'ok') {
          this.otpEnableYn = _.get(res, ['result', 'admin_otp_enable_yn'], 0)

          this.disableReLogin = typeof disableReLogin !== 'undefined' ? disableReLogin : false

          // 로그인 아이디 저장
          this.loginId = loginId

          // 잠금화면 출력
          this.isShow = true

          // 패스워드 초기화
          this.password = ''
        }
      },
      hide () {
        // 잠금화면 숨김
        this.isShow = false

        // 잠금모드 해제
        this.$emit('releaseLockMode')
      },
      async validate () {
        const checkResult = await this.validateMixins('lock')
        return checkResult
      },
      /*
        이름: onClickCheckPassword
        설명: 입력된 패스워드를 서버로 전달한다. 패스워드가 일치하면 팝업을 닫는다.
      */
      async onClickCheckPassword () {
        try {
          const isValid = await this.validate()
          // 비밀번호는 필수 입력사항
          if (!isValid) {
            return
          }

          const username = this.$store.state.common.common.authUser.login_id,
            // password = encryptionPassword(this.csrfToken, this.password)
            password = encryptionPassword(this.encryptionAesKey, this.password)

          const params = {username, password}

          if (this.otpEnableYn === 1) {
            params['admin_otp'] = this.otpKey
            params['admin_otp_type'] = 1
          }

          // 비밀번호가 들어오면 API 호출
          const res = await this.unlock(params)

          if (res.code === 'ok') {
            this.hide()
          } else {
            this.$alertPopUp.show(res.result.msg, 'error')
          }
        } catch (e) {
          this.$log('[Lock Screen Popup GUI Error (onClickCheckPassword)]', e)
        }
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .global-lockscreen-no-transition {
    transition: all 0s ease-in-out !important;
  }

  .global-lockscreen-container {
    width: 100%;
    height: 100%;
    z-index: 10000;
    background-color: #f5f6fa;
  }
</style>
